import { FC, Dispatch, SetStateAction } from "react";

interface ICollapsables {
  information_for_ordering_offices: boolean;
  terms_and_conditions: boolean;
  labor_category_descriptions: boolean;
  labor_rates: boolean;
}

interface IProps {
  isCollapsed: ICollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ICollapsables>>;
}

export const InformationForOrderingOffices: FC<IProps> = ({
  isCollapsed,
  setIsCollapsed,
}) => {
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            information_for_ordering_offices: !isCollapsed.information_for_ordering_offices,
          })
        }
        className="collapsable"
      >
        Information for Ordering Offices
        <i
          className={
            isCollapsed.information_for_ordering_offices
              ? "fas fa-caret-down"
              : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.information_for_ordering_offices ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                information_for_ordering_offices: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <div className="general_info">
          <span>GSA Contract Number - GS-35F-068GA</span>
          <span>Professional Software Engineering, Inc. (t/a PROSOFT)</span>
          <div className="general_info__contact">
            <span>500 Viking Drive, Suite 301</span>
            <span>Virginia Beach, VA 23452-7477</span>
            <span>(757) 431-2400</span>
          </div>
          <span className="general_info__subheader">
            INFORMATION FOR ORDERING OFFICES
          </span>
        </div>
        <div className="notice">
          <p>SPECIAL NOTICE TO AGENCIES:</p>
          <p className="text-center">Small Business Participation</p>
          <p>
            SBA strongly supports the participation of small business concerns
            in the Federal Supply Schedules Program. To enhance Small Business
            Participation SBA policy allows agencies to include in their
            procurement base and goals, the dollar value of orders expected to
            be placed against the Federal Supply Schedules, and to report
            accomplishments against these goals.
          </p>
          <p>
            For orders exceeding the micropurchase threshold, FAR 8.404 requires
            agencies to consider the catalogs/pricelists of at least three
            schedule contractors or consider reasonably available information by
            using the GSA Advantage on-line shopping service (www.fss.gsa.gov).
            The catalogs/pricelists, GSA Advantage and the Federal Supply
            Service Home Page (www.fss.gsa.gov) contains information on a broad
            array of products and services offered by small business concerns.
          </p>
          <p>
            This information should be used as a tool to assist ordering
            activities in meeting or exceeding established small business goals.
            It should also be used as a tool to assist in including small, small
            disadvantaged, and women-owned small businesses among those
            considered when selecting pricelists for a best value determination.
          </p>
          <p>
            For orders exceeding the micropurchase threshold, customers are to
            give preference to small business concerns when two or more items at
            the same delivered price will satisfy their requirement.
          </p>
          <ol>
            <li>Geographic Scope of Contract</li>
            <p>
              The geographic scope of this contract is the 48 contiguous states,
              the District of Columbia, Alaska, Hawaii, the Commonwealth of
              Puerto Rico, and all U.S. Government installations and/or agencies
              abroad.
            </p>
            <li>Contractor's Ordering Address and Payment Information:</li>
            <p className="underline">Contractor's Ordering Information</p>
            <div className="contact">
              <span>Professional Software Engineering, Inc. (T/A PROSOFT)</span>
              <span>500 Viking Drive, Suite 301</span>
              <span>Virginia Beach, VA 23452-7477</span>
              <span>Attn: Mr. Phil Eagan</span>
            </div>
            <p className="underline">Contractor's Payment Address</p>
            <div className="contact">
              <span>Professional Software Engineering, Inc. (T/A PROSOFT)</span>
              <span>500 Viking Drive, Suite 301</span>
              <span>Virginia Beach, VA 23452-7477</span>
              <span>Attn: Mr. Phil Eagan</span>
            </div>
            <p>
              Contractors are required to accept the Government purchase card
              for payments equal to or less than the micro-purchase threshold
              for oral or written delivery orders. Government purchase cards
              will be acceptable for payment above the micro-purchase threshold.
              In addition, bank account information for wire transfer payments
              will be shown on the invoice.
            </p>
            <p>
              The following telephone number can be used by ordering agencies to
              obtain technical and/or ordering assistance:
            </p>
            <span className="text-center bold">(757) 431-2400</span>
            <li>LIABILITY FOR INJURY OR DAMAGE</li>
            <p>
              The Contractor shall not be liable for any injury to Government
              personnel or damage to Government property arising from the use of
              equipment maintained by the Contractor, unless such injury or
              damage is due to the fault or negligence of the Contractor.
            </p>
            <li>
              Statistical Data for Government Ordering Office Completion of
              Standard Form 279:
            </li>
            <div className="sf279">
              <span>Block 9: G. Order/Modification Under Federal Schedule</span>
              <span>
                Block 16: Data Universal Numbering System (DUNS) Number:
                15-338-6891
              </span>
              <span>
                Block 30: Type of Contractor - A. Small Disadvantaged Business
              </span>
              <span>Block 31: Woman-Owned Small Business - No</span>
              <span>
                Block 36: Contractor's Taxpayer Identification Number (TIN)
                54-1318467
              </span>
              <span>a. CAGE Code: 1HK66</span>
              <span>
                b. Contractor has registered with the Central Contractor
                Registration Database.
              </span>
            </div>
            <li>FOB DESTINATION</li>
            <li>DELIVERY SCHEDULE</li>
            <p>
              a. TIME OF DELIVERY: The Contractor shall deliver to destination
              within the number of calendar days after receipt of order (ARO),
              as set forth below:
            </p>
            <table className="delivery_schedule_content">
              <tr>
                <th>SPECIAL ITEM NUMBER</th>
                <th>DELIVERY TIME (Days ARO)</th>
              </tr>
              <tr>
                <td>132-51</td>
                <td>As negotiated between contractor and ordering agency.</td>
              </tr>
              <tr>
                <td>70-500</td>
                <td>As negotiated between contractor and ordering agency.</td>
              </tr>
            </table>
            <p>
              b. URGENT REQUIREMENTS: When the Federal Supply Schedule contract
              delivery period does not meet the bona fide urgent delivery
              requirements of an ordering agency, agencies are encouraged, if
              time permits, to contact the Contractor for the purpose of
              obtaining accelerated delivery. The Contractor shall reply to the
              inquiry within 3 workdays after receipt. (Telephonic replies shall
              be confirmed by the Contractor in writing.) If the Contractor
              offers an accelerated delivery time acceptable to the ordering
              agency, any order(s) placed pursuant to the agreed upon
              accelerated delivery time frame shall be delivered within this
              shorter delivery time and in accordance with all other terms and
              conditions of the contract.
            </p>
            <li>Discounts:</li>
            <p>
              Prices shown are NET Prices; Basic Discounts have been deducted.
            </p>
            <p>
              a. Prompt Payment: None - Net 30 days from receipt of invoice or
              date of acceptance, whichever is later.
            </p>
            <p>b. Quantity: As reflected in the price list.</p>
            <p>c. Dollar Volume: None</p>
            <p>
              d. Government Educational Institutions: Offered the same discounts
              as all other Government customers.
            </p>
            <li>Trade Agreements Act of 1979, as amended:</li>
            <p>
              All items are U.S. made end products, designated country end
              products, Caribbean Basin country end products, Canadian end
              products, or Mexican end products as defined in the Trade
              Agreements Act of 1979, as amended.
            </p>
            <li>Statement Concerning Availability of Export Packing:</li>
            <p>
              Export packing is available at extra cost outside the scope of
              this contract.
            </p>
            <li>Small Requirements:</li>
            <p>The minimum dollar value of orders to be issued is $100.</p>
            <li>Maximum Order:</li>
            <p>
              (All dollar amounts are exclusive of any discount for prompt
              payment.)
            </p>
            <p>
              The maximum order threshold for this contract is $500,000. This
              threshold represents the point where it is advantageous for the
              ordering office to seek a price reduction or discount from the
              established pricelist, per item 12. c. below.
            </p>
            <li>
              USE OF FEDERAL SUPPLY SERVICE INFORMATION TECHNOLOGY SCHEDULE
              CONTRACTS
            </li>
            <p>In accordance with FAR 8.404:</p>
            <p>
              [NOTE: Special ordering procedures have been established for
              Special Item Number (SIN) 132-51 IT Professional Services; refer
              to the terms and conditions for those SINs.]
            </p>
            <p>
              Orders placed pursuant to a Multiple Award Schedule (MAS), using
              the procedures in FAR 8.404, are considered to be issued pursuant
              to full and open competition. Therefore, when placing orders under
              Federal Supply Schedules, ordering offices need not seek further
              competition, synopsize the requirement, make a separate
              determination of fair and reasonable pricing, or consider small
              business set-asides in accordance with subpart 19.5. GSA has
              already determined the prices of items under schedule contracts to
              be fair and reasonable. By placing an order against a schedule
              using the procedures outlined below, the ordering office has
              concluded that the order represents the best value and results in
              the lowest overall cost alternative (considering price, special
              features, administrative costs, etc.) to meet the Government's
              needs.
            </p>
            <p>
              a. Orders placed at or below the micro-purchase threshold.
              Ordering offices can place orders at or below the micro-purchase
              threshold with any Federal Supply Schedule Contractor.
            </p>
            <p>
              b. Orders exceeding the micro-purchase threshold but not exceeding
              the maximum order threshold. Orders should be placed with the
              Schedule Contractor that can provide the supply or service that
              represents the best value. Before placing an order, ordering
              offices should consider reasonably available information about the
              supply or service offered under MAS contracts by using the "GSA
              Advantage!" on-line shopping service, or by reviewing the
              catalogs/pricelists of at least three Schedule Contractors and
              selecting the delivery and other options available under the
              schedule that meets the agency's needs. In selecting the supply or
              service representing the best value, the ordering office may
              consider--
            </p>
            <p>
              (1) Special features of the supply or service that are required in
              effective program performance and that are not provided by a
              comparable supply or service;
            </p>
            <p>(2) Trade-in considerations;</p>
            <p>
              (3) Probable life of the item selected as compared with that of a
              comparable item;
            </p>
            <p>(4) Warranty considerations;</p>
            <p>(5) Maintenance availability;</p>
            <p>(6) Past performance; and</p>
            <p>(7) Environmental and energy efficiency considerations.</p>
            <p>
              c. Orders exceeding the maximum order threshold. Each schedule
              contract has an established maximum order threshold. This
              threshold represents the point where it is advantageous for the
              ordering office to seek a price reduction. In addition to
              following the procedures in paragraph b, above, and before placing
              an order that exceeds the maximum order threshold, ordering
              offices shall--
            </p>
            <p>
              (1) Review Additional Schedule Contractors' catalogs/pricelists or
              use the "GSA Advantage!" on-line shopping service;
            </p>
            <p>
              (2) Based upon the initial evaluation, generally seek price
              reductions from the Schedule Contractor(s) appearing to provide
              the best value (considering price and other factors); and
            </p>
            <p>
              (3) After price reductions have been sought, place the order with
              the Schedule Contractor that provides the best value and results
              in the lowest overall cost alternative. If further price
              reductions are not offered, an order may still be placed, if the
              ordering office determines that it is appropriate.
            </p>
            <p>
              NOTE: For orders exceeding the maximum order threshold, the
              Contractor may:
            </p>
            <p>
              (1) Offer a new lower price for this requirement (the Price
              Reductions clause is not applicable to orders placed over the
              maximum order in FAR 52.216-19 Order Limitations);
            </p>
            <p>(2) Offer the lowest price available under the contract; or</p>
            <p>
              (3) Decline the order (orders must be returned in accordance with
              FAR 52.216-19).
            </p>
            <p>
              d. Blanket purchase agreements (BPAs). The establishment of
              Federal Supply Schedule BPAs is permitted when following the
              ordering procedures in FAR 8.404. All schedule contracts contain
              BPA provisions. Ordering offices may use BPAs to establish
              accounts with Contractors to fill recurring requirements. BPAs
              should address the frequency of ordering and invoicing, discounts,
              and delivery locations and times.
            </p>
            <p>
              e. Price reductions. In addition to the circumstances outlined in
              paragraph c, above, there may be instances when ordering offices
              will find it advantageous to request a price reduction. For
              example, when the ordering office finds a schedule supply or
              service elsewhere at a lower price or when a BPA is being
              established to fill recurring requirements, requesting a price
              reduction could be advantageous. The potential volume of orders
              under these agreements, regardless of the size of the individual
              order, may offer the ordering office the opportunity to secure
              greater discounts. Schedule Contractors are not required to pass
              on to all schedule users a price reduction extended only to an
              individual agency for a specific order.
            </p>
            <p>
              f. Small business. For orders exceeding the micro-purchase
              threshold, ordering offices should give preference to the items of
              small business concerns when two or more items at the same
              delivered price will satisfy the requirement.
            </p>
            <p>
              g. Documentation. Orders should be documented, at a minimum, by
              identifying the Contractor the item was purchased from, the item
              purchased, and the amount paid. If an agency requirement in excess
              of the micro-purchase threshold is defined so as to require a
              particular brand name, product, or feature of a product peculiar
              to one manufacturer, thereby precluding consideration of a product
              manufactured by another company, the ordering office shall include
              an explanation in the file as to why the particular brand name,
              product, or feature is essential to satisfy the agency's needs.
            </p>
            <li>
              FEDERAL INFORMATION TECHNOLOGY / TELECOMMUNICATION STANDARDS
              REQUIREMENTS:
            </li>
            <p>
              Federal departments and agencies acquiring products from this
              Schedule must comply with the provisions of the Federal Standards
              Program, as appropriate (reference: NIST Federal Standards Index).
              Inquiries to determine whether or not specific products listed
              herein comply with Federal Information Processing Standards (FIPS)
              or Federal Telecommunication Standards (FED-STDS), which are cited
              by ordering offices, shall be responded to promptly by the
              Contractor.
            </p>
            <p className="sub-category">
              13.1 FEDERAL INFORMATION PROCESSING STANDARDS PUBLICATIONS (FIPS
              PUBS):
            </p>
            <p>
              Information Technology products under this Schedule that do not
              conform to Federal Information Processing Standards (FIPS) should
              not be acquired unless a waiver has been granted in accordance
              with the applicable "FIPS Publication." Federal Information
              Processing Standards Publications (FIPS PUBS) are issued by the
              U.S. Department of Commerce, National Institute of Standards and
              Technology (NIST), pursuant to National Security Act. Information
              concerning their availability and applicability should be obtained
              from the National Technical Information Service (NTIS), 5285 Port
              Royal Road, Springfield, Virginia 22161. FIPS PUBS include
              voluntary standards when these are adopted for Federal use.
              Individual orders for FIPS PUBS should be referred to the NTIS
              Sales Office, and orders for subscription service should be
              referred to the NTIS Subscription Officer, both at the above
              address, or telephone number (703) 487-4650.
            </p>
            <p className="sub-category">
              13.2 FEDERAL TELECOMMUNICATION STANDARDS (FED-STDS):
            </p>
            <p>
              Telecommunication products under this Schedule that do not conform
              to Federal Telecommunication Standards (FED-STDS) should not be
              acquired unless a waiver has been granted in accordance with the
              applicable "FED-STD." Federal Telecommunication Standards are
              issued by the U.S. Department of Commerce, National Institute of
              Standards and Technology (NIST), pursuant to National Security
              Act. Ordering information and information concerning the
              availability of FED-STDS should be obtained from the GSA, Federal
              Supply Service, Specification Section, 470 East L'Enfant Plaza,
              Suite 8100, SW, Washington, DC 20407, telephone number (202)
              619-8925. Please include a self-addressed mailing label when
              requesting information by mail. Information concerning their
              applicability can be obtained by writing or calling the U.S.
              Department of Commerce, National Institute of Standards and
              Technology, Gaithersburg, MD 20889, telephone number (301)
              975-2833.
            </p>
            <li>SECURITY REQUIREMENTS:</li>
            <p>
              In the event security requirements are necessary, the ordering
              activities may incorporate, in their delivery orders, a security
              clause in accordance with current laws, regulations, and
              individual agency policy; however, the burden of administering the
              security requirements shall be with the ordering agency. If any
              costs are incurred as a result of the inclusion of security
              requirements, such costs will not exceed ten percent (10%) or
              $100,000, of the total dollar value of the order, whichever is
              lessor.
            </p>
            <li>CONTRACT ADMINISTRATION FOR ORDERING OFFICES:</li>
            <p>
              Any ordering office, with respect to any one or more delivery
              orders placed by it under this contract, may exercise the same
              rights of termination as might the GSA Contracting Officer under
              provisions of FAR 52.212-4, paragraphs (l) Termination for the
              Government's convenience, and (m) Termination for Cause (See C.1.)
            </p>
            <li>GSA Advantage</li>
            <p>
              GSA Advantage is an on-line, interactive electronic information
              and ordering system that provides on-line access to vendors'
              schedule prices with ordering information. GSA Advantage! will
              allow the user to perform various searches across all contracts
              including, but not limited to:
            </p>
            <p>(1) Manufacturer;</p>
            <p>(2) Manufacturer's Part Number; and</p>
            <p>(3) Product categories</p>
            <p>
              Agencies can browse GSA Advantage! by accessing the Internet World
              Wide Web utilizing a browser. The Internet address is
              https://gsaadvantage.gsa.gov/advantage/main/start_page.do.
            </p>
            <li>PURCHASE OF INCIDENTAL, NON-SCHEDULE ITEMS</li>
            <p>
              For administrative convenience, open market (non-contract) items
              may be added to a Federal Supply Schedule Blanket Purchase
              Agreement (BPA) or an individual order, provided that the items
              are clearly labeled as such on the order, all applicable
              regulations have been followed, and price reasonableness has been
              determined by the ordering activity for the open market
              (non-contract) items.
            </p>
            <li>CONTRACTOR COMMITMENTS, WARRANTIES AND REPRESENTATIONS</li>
            <p>
              a. For the purpose of this contract, commitments, warranties and
              representations include, in addition to those agreed to for the
              entire schedule contract:
            </p>
            <p>
              (1) Time of delivery/installation quotations for individual
              orders;
            </p>
            <p>
              (2) Technical representations and/or warranties of products
              concerning performance, total system performance and/or
              configuration, physical, design and/or functional characteristics
              and capabilities of a product/equipment/ service/software package
              submitted in response to requirements which result in orders under
              this schedule contract.
            </p>
            <p>
              (3) Any representations and/or warranties concerning the products
              made in any literature, description, drawings and/or
              specifications furnished by the Contractor.
            </p>
            <p>
              b. The above is not intended to encompass items not currently
              covered by the GSA Schedule contract.
            </p>
            <li>OVERSEAS ACTIVITIES</li>
            <p>
              The terms and conditions of this contract shall apply to all
              orders for installation, maintenance and repair of equipment in
              areas listed in the pricelist outside the 48 contiguous states and
              the District of Columbia, except as indicated below:
            </p>
            <p>
              ___None_________________________________________________________________
            </p>
            <p>
              Upon request of the Contractor, the Government may provide the
              Contractor with logistics support, as available, in accordance
              with all applicable Government regulations. Such Government
              support will be provided on a reimbursable basis, and will only be
              provided to the Contractor's technical personnel whose services
              are exclusively required for the fulfillment of the terms and
              conditions of this contract.
            </p>
            <li>BLANKET PURCHASE AGREEMENTS</li>
            <p>
              Federal Acquisition Regulation (FAR) 13.303-I(a) defines Blanket
              Purchase Agreements (BPAs) as "…a simplified method of filling
              anticipated repetitive needs for supplies or services by
              establishing 'charge accounts' with qualified sources of supply."
              The use of Blanket Purchase Agreements under the Federal Supply
              Schedule Program is authorized in accordance with FAR
              13.303-2(c)(3), which reads in part, as follows:
            </p>
            <p>
              "BPAs may be established with Federal Supply Schedule Contractors,
              if not inconsistent with the terms of the applicable schedule
              contract."
            </p>
            <p>
              Federal Supply Schedule contracts contain BPA provisions to enable
              schedule users to maximize their administrative and purchase
              savings. This feature permits schedule users to set up "accounts"
              with Schedule Contractors to fill recurring requirements. These
              accounts establish a period for the BPA and generally address
              issues such as the frequency of ordering and invoicing, authorized
              callers, discounts, delivery locations and times. Agencies may
              qualify for the best quantity/volume discounts available under the
              contract, based on the potential volume of business that may be
              generated through such an agreement, regardless of the size of the
              individual orders. In addition, agencies may be able to secure a
              discount higher than that available in the contract based on the
              aggregate volume of business possible under a BPA. Finally,
              contractors may be open to a progressive type of discounting where
              the discount would increase once the sales accumulated under the
              BPA reach certain prescribed levels. Use of a BPA may be
              particulary useful with the new Maximum Order feature. See the
              suggested format, contained in this Schedule Pricelist, for
              customers to consider when using this purchasing tool.
            </p>
            <li>CONTRACTOR TEAM ARRANGEMENTS</li>
            <p>
              Contractors participating in contractor team arrangements must
              abide by all terms and conditions of their respective contracts.
              This includes compliance with Clauses 552.238-74, Contractor's
              Reports of Sales and 552.238-76, Industrial Funding Fee, i.e.,
              each contractor (team member) must report sales and remit the IFF
              for all products and services provided under its individual
              contract.
            </p>
            <li>INSTALLATION, DEINSTALLATION, REINSTALLATION</li>
            <p>
              The Davis-Bacon Act (40 U.S.C. 276a-276a-7) provides that
              contracts in excess of $2,000 to which the United States or the
              District of Columbia is a party for construction, alteration, or
              repair (including painting and decorating) of public buildings or
              public works with the United States, shall contain a clause that
              no laborer or mechanic employed directly upon the site of the work
              shall receive less than the prevailing wage rates as determined by
              the Secretary of Labor. The requirements of the Davis-Bacon Act do
              not apply if the construction work is incidental to the furnishing
              of supplies, equipment, or services. For example, the requirements
              do not apply to simple installation or alteration of a public
              building or public work that is incidental to furnishing supplies
              or equipment under a supply contract. However, if the
              construction, alteration or repair is segregable and exceeds
              $2,000, then the requirements of the Davis-Bacon Act applies.
            </p>
            <p>
              The Requisitioning activity issuing the task order against this
              contract will be responsible for proper administration and
              enforcement of the Federal labor standards covered by the
              Davis-Bacon Act.
            </p>
            <li>SECTION 508 COMPLIANCE</li>
            <p>
              Section 508 compliance information on the supplies and services in
              this contract are available in Electronic and Information
              Technology (EIT) at www.Section508.gov/.
            </p>
          </ol>
        </div>
      </div>
    </div>
  );
};
